import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, OnInit, TemplateRef, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrollPadding } from '../../core/common/entities/scroll-padding.entity';
import { ShScrollPaddingService } from '../../core/common/services/scroll-padding/scroll-padding.service';

@Component({
    selector: 'sh-main-layout',
    templateUrl: './main-layout.component.html',
    standalone: true,
    imports: [NgIf, NgTemplateOutlet, AsyncPipe]
})
export class MainLayoutComponent implements OnInit {
    @ContentChild('logo') logoContent: TemplateRef<any>;
    @ContentChild('links') linksContent: TemplateRef<any>;
    @ContentChild('main') mainContent: TemplateRef<any>;

    public scrollPadding$: Observable<ScrollPadding | undefined>;

    // Injectors
    private readonly scrollPaddingService: ShScrollPaddingService = inject(ShScrollPaddingService);

    ngOnInit(): void {
        this.scrollPadding$ = this.scrollPaddingService.getScrollPadding();
    }
}
